var parent = require('../../es/instance/slice');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/instance/slice.js
// module id = 1014
// module chunks = 0